import { IconFileExcel } from '@shared/icon/icon-file-excel/icon-file-excel';
import { IconFilePdf } from '@shared/icon/icon-file-pdf/icon-file-pdf';
import { IconFilePowerPoint } from '@shared/icon/icon-file-power-point/icon-file-power-point';
import { IconFileWord } from '@shared/icon/icon-file-word/icon-file-word';

export const ICON_MAP: Record<string, JSX.Element> = {
    /* word */
    doc: <IconFileWord />,
    docx: <IconFileWord />,
    /* power point */
    ppt: <IconFilePowerPoint />,
    pptx: <IconFilePowerPoint />,
    /* pdf */
    pdf: <IconFilePdf />,
    /* excel */
    xlsx: <IconFileExcel />,
    xlsm: <IconFileExcel />,
    xlsb: <IconFileExcel />,
    xltx: <IconFileExcel />,
    xltm: <IconFileExcel />,
    xls: <IconFileExcel />,
    xlt: <IconFileExcel />,
    xml: <IconFileExcel />,
    xlam: <IconFileExcel />,
    xla: <IconFileExcel />,
    xlw: <IconFileExcel />,
    xlr: <IconFileExcel />,
};
